// Lazy-loads the mobile menu drawer contents (snippets/mobile-menu.liquid) so they are not part of
// every page's HTML. The markup comes from /?view=mobile-menu (templates/index.mobile-menu.json),
// where the header renders the full drawer: first as just the header section, else as the whole page.
// To avoid a wait on the first tap it is:
//   - reused from sessionStorage for 30 minutes (per guest / logged-in customer),
//   - preloaded in the background once the page has loaded on screens where the drawer is used,
//   - otherwise loaded as soon as the menu button is touched, hovered or focused.
(function () {
  'use strict';

  var shell = document.querySelector('#mobileMenu[data-lazy-mobile-menu]');
  if (!shell) return;

  var button = document.querySelector('[data-mobile-menu]');
  var MOBILE_MAX_WIDTH = 1024;
  var CACHE_TTL = 30 * 60 * 1000;
  var customerId = (window.__st && window.__st.cid) || 'guest';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CACHE_KEY = 'mobileMenuDrawer:v1:' + root + ':' + customerId;
  var loading = null;

  function readCache() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && Date.now() - cached.time < CACHE_TTL && cached.html) return cached.html;
    } catch (e) {}
    return null;
  }

  function writeCache(html) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), html: html }));
    } catch (e) {}
  }

  function headerSectionId() {
    var section = shell.closest('.shopify-section');
    return section ? section.id.replace(/^shopify-section-/, '') : null;
  }

  function extractDrawer(html) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var drawer = doc.querySelector('#mobileMenu');
    if (!drawer || drawer.hasAttribute('data-lazy-mobile-menu') || !drawer.children.length) return null;
    return drawer.innerHTML;
  }

  function fetchDrawer() {
    var url = root + '?view=mobile-menu';
    var id = headerSectionId();

    var viaSection = id
      ? fetch(url + '&sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (json) { return json && extractDrawer(json[id]); })
          .catch(function () { return null; })
      : Promise.resolve(null);

    return viaSection.then(function (html) {
      if (html) return html;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(extractDrawer);
    });
  }

  function insert(html) {
    shell.innerHTML = html;
    shell.removeAttribute('data-lazy-mobile-menu');

    var header = shell.closest('.main-header') || document.querySelector('.main-header');
    if (header && typeof window.bindMobileDrawerItems === 'function') {
      window.bindMobileDrawerItems(header, shell);
    }
    if (window.jQuery && typeof window.initMobileMenuDrawer === 'function') {
      window.initMobileMenuDrawer(window.jQuery(shell));
    }
  }

  function load() {
    if (loading) return loading;

    var cached = readCache();
    if (cached) {
      insert(cached);
      loading = Promise.resolve();
      return loading;
    }

    loading = fetchDrawer()
      .then(function (html) {
        if (!html) throw new Error('Mobile menu markup not found');
        insert(html);
        writeCache(html);
      })
      .catch(function (error) {
        loading = null;
        var message = shell.querySelector('[data-mobile-menu-loading]');
        if (message) message.textContent = 'Menu could not be loaded. Tap here to try again.';
        console.warn(error);
      });
    return loading;
  }

  if (button) {
    ['touchstart', 'pointerenter', 'focus'].forEach(function (type) {
      button.addEventListener(type, load, { passive: true });
    });
    button.addEventListener('click', load);
  }

  shell.addEventListener('click', function (event) {
    if (event.target.closest('[data-mobile-menu-loading]')) load();
  });

  // Preload where the drawer is actually used, after the page itself has finished loading
  function preload() {
    if (window.innerWidth > MOBILE_MAX_WIDTH) return;
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(load, { timeout: 3000 });
    } else {
      setTimeout(load, 1500);
    }
  }

  if (readCache()) {
    load();
  } else if (document.readyState === 'complete') {
    preload();
  } else {
    window.addEventListener('load', preload);
  }
})();
